import React, { useState, useRef } from 'react';
import {Card} from "react-bootstrap";
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Row from 'react-bootstrap/Row';
import {useAuth} from "../../AuthUser";
import {toast} from "react-toastify";

const APIKey = () => {
	const { user } = useAuth();
	const [inputValue, setInputValue] = useState('');
	const inputRef = useRef(null);

	const handleCopy = async (e) => {
		if (inputRef.current) {
			e.preventDefault();
			try {
				await navigator.clipboard.writeText(inputRef.current.value);
				toast.success('API Key copied!', {
					position: toast.POSITION.TOP_RIGHT,
				});
			} catch (err) {
				console.error('Failed to copy text: ', err);
				alert('Failed to copy text');
			}
		}
	};
	return (
				<>
					<Card>
						<Card.Header as="h5">API Key</Card.Header>
						<Card.Body>
							<Card.Text>
								<div>
									<p>Some partners may need your API Key to connect with MyGolfDNA. Copy the key below and paste it where requested.</p>
									<Form>
										<Row className="align-items-center">
											<Col lg={6}>
												<Form.Label htmlFor="inlineFormInput" visuallyHidden>
													APIKey
												</Form.Label>
												<Form.Control
													className="mb-2"
													id="inlineFormInput"
													disabled={true}
													value={user.apiKey}
													ref={inputRef}
												/>
											</Col>
											<Col xs="auto">
												<Button type="submit" className="mb-2" onClick={handleCopy}>
													Copy
												</Button>
											</Col>
										</Row>
									</Form>
								</div>
							</Card.Text>

						</Card.Body>
					</Card>
				</>
	);
};

export default APIKey;
